import { render } from "./InitialAgreement.vue?vue&type=template&id=3c7afbb3"
import script from "./InitialAgreement.vue?vue&type=script&lang=js"
export * from "./InitialAgreement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__